export * from './past-stay';



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/past-stay/index.ts